import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot } from "..";
import { Spinner } from "react-bootstrap";

const ArticleUpdate = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();

  const {articleKey} = location.state;

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const fetchArticleQuery = useQuery(['fetchArticle'], async () => {
    const {data} = await axios.get(apiRoot + '/articles/' + articleKey);
    return data;
  }, 
  {
    onSuccess: (data) => {
      setInputs({
        header: data.header,
        content: data.content
      });
    },
    onError: (err) => {
      console.log('fetchArticle error: ' + err) // TODO
    }
  });

  const updateArticleMutation = useMutation((article) => {
    return axios.post(apiRoot  + '/articles/' + articleKey, article);
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchArticle']);
      navigate("/aktuality"); // TODO
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!updateArticleMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.header || !inputs.content) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    updateArticleMutation.mutate(inputs);
  }

  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-pencil fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Upravit článek</h2>
</span>
</div>

{fetchArticleQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchArticleQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání článku.</div>
}
{fetchArticleQuery.data &&
<form onSubmit={handleSubmit}>

<table>
<tbody>
<tr>
<td>{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}</td>
</tr><tr>
<td><strong>Titulek:</strong></td>
</tr><tr>
<td><input type="text" className="form-control" name="header" size="70" value={inputs.header || ""} onChange={handleChange} /></td>
</tr><tr>
<td><strong>Obsah:</strong> <em>(umožňuje formátování pomocí <a href="http://www.edgering.org/markdown/" target="_blank" rel="noreferrer">Markdown značek</a>)</em></td>
</tr><tr>
<td><textarea className="form-control" name="content" cols="100" rows="40" value={inputs.content || ""} onChange={handleChange} /></td>
</tr><tr>
<td><button type="submit" className="btn btn-success" disabled={updateArticleMutation.isLoading}><i className="fa fa-check" aria-hidden="true"></i> Upravit článek</button>
{updateArticleMutation.isLoading ? (<> <Spinner as="span" animation="border" size="sm" /></>) : (<></>)}</td>
</tr>
</tbody>
</table>

</form>
}
    </>
  );
};

export default ArticleUpdate;